import React, { useState } from 'react';
import { Link } from 'react-scroll'
import { NavLink } from 'react-router-dom'
import Bg from '../../images/shapes/btn_mask_bg.png'
import shapeCartoon2 from '../../images/shapes/shape_cartoon_6.png';
import shapeCartoon3 from '../../images/shapes/shape_cartoon_7.png';
import logo from '../../images/site_logo/logo.png';
import './Footer.css';
import Modal from '../Modal/Modal';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  }

  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);



  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const id = location.hash.replace('#', '');
        const el = document.getElementById(id);
        if (el) {
          const yOffset = -50; // adjust this for header height
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 100); // Wait a moment for DOM/render
    }
  }, [location]);

  return (
    <footer className="meme_site_footer section_decoration pb-0">
      <div className="container">
        <h2
          className="footer_heading text-center text-uppercase"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          Let’s Get Started
        </h2>
        <ul
          className="pagelist_block unordered_list justify-content-center text-uppercase"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-delay="100"
        >
          <li>
            <NavLink to="/#id_token_offer" spy={true} smooth={true} duration={500} offset={-100}>
              <span className="pagelist_label">Exclusive Deal</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/#id_memecoin_service_section" spy={true} smooth={true} duration={500} offset={-100}>
              <span className="pagelist_label">Features</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/#how_to_buy_memecoin_section" spy={true} smooth={true} duration={500} offset={-100}>
              <span className="pagelist_label">our services</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/#id_meme_roadmap_section" spy={true} smooth={true} duration={500} offset={-100}>
              <span className="pagelist_label">Roadmap</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/#meme_tokenomics_section" spy={true} smooth={true} duration={500} offset={-100}>
              <span className="pagelist_label">Package breakdown</span>
            </NavLink>
          </li>
        </ul>
        <ul
          className="btns_group unordered_list justify-content-center pb-0" style={{ marginBottom: '5rem' }}
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-delay="200"
        >
          <li>
            <NavLink className="memecoin_btn bg-white" to="/" onClick={ClickHandler}>
              <span className="btn_label">Explore Pre-made logos</span>
              <span
                className="btn_bg"
                style={{ maskImage: `url(${Bg})` }}
              ></span>
            </NavLink>
          </li>
          <li>
            <button className="memecoin_btn bg-light" onClick={openModal}>
              <span className="btn_label">Get a Free Quote</span>
              <span
                className="btn_bg"
                style={{ maskImage: `url(${Bg})` }}
              ></span>
            </button>
          </li>
        </ul>
      </div>


      <div className='container footer-content'>
        <div className='row'>
          <div className='col-lg-4'>
            <img src={logo} alt='footer-logo' />
            <p className='text'>We are Branding and Marketing Agency that will Give Life To Your Ideas And Vision!</p>
          </div>
          <div className='col-lg-2'>
            <h5>SERVICES</h5>
            <ul>
              <li><NavLink to="/logo-design">Logo Design</NavLink></li>
              <li><NavLink to="/website-design">Website Design</NavLink></li>
              <li><NavLink to="/animation-and-illustration">Animation And Illustration</NavLink></li>
            </ul>
          </div>
          <div className='col-lg-2'>
            <h5>PACKAGES</h5>
            <ul>
              <li><NavLink to="/website-design#packages">Web Design Packages</NavLink></li>
              <li><NavLink to="/logo-design#packages">Logo Design Packages</NavLink></li>
              <li><NavLink to="/animation-and-illustration#packages">Animation And Illustration Packages</NavLink></li>
            </ul>
          </div>
          <div className='col-lg-2'>
            <h5>CONTACT</h5>
            <ul>
              <li><a href='tel:+1 (888) 784-0464'>+1 (888) 784-0464</a></li>
              <li><a href='mailto:info@getlogoandwebsite.com'>info@getlogoandwebsite.com</a></li>
              <li>Mon - Fri 9 AM - 7 PM EST</li>
              <li>1721 Greenhouse Rd apt 3413 Houston Tx</li>
            </ul>
          </div>
        </div>
      </div>

      {/* <div className="decoration_item cartoon_shape_1">
        <img src={shapeCartoon1} alt="Cartoon" />
      </div> */}
      <div className="decoration_item cartoon_shape_2">
        <img src={shapeCartoon2} alt="Cartoon" />
      </div>
      <div className="decoration_item cartoon_shape_3">
        <img src={shapeCartoon3} alt="Cartoon" />
      </div>

      <div className='footer_bottom'>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <p className="copyright_text m-0">
                Copyright© 2025 <NavLink to='/'>GetLogoAndWebsite</NavLink>. All rights reserved.
              </p>
            </div>
            <div className="col-lg-6">
              <ul className="social_block unordered_list justify-content-lg-end">
                <li>
                  <NavLink to="https://www.instagram.com/getlogoandwebsite/">
                    <i className="fa-brands fa-instagram"></i>
                  </NavLink>
                </li>
                <li>
                  <NavLink to="https://www.facebook.com/people/Get-Logo-Website/61577635406172/">
                    <i className="fa-brands fa-facebook"></i>
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && <Modal onClose={closeModal} />}
    </footer>
  );
};

export default Footer;
